import clsx from '@/lib/clsx';

const WizardHeader = ({ children, className = '', style = {}, ...props }) => {
  return (
    <div className={clsx('comp-wizard-header', className)} style={style} {...props}>
      {children}
    </div>
  );
};

export default WizardHeader;
